// N2N template
import './plugins/font-awesome';
import './plugins/tippy-js';
import './plugins/vue-mq';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';

import Vue from 'vue';
import App from './App.vue';
import router from './router';

// Bootstrap vue
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// Vue CTK Date time picker
// @ts-ignore
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

// veevalidate v3
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Validation rules
import { required, email, regex, between, min, min_value, max_value, confirmed } from 'vee-validate/dist/rules';
import { ValidateRules } from './util/ValidateRules';
extend('confirmed', {...confirmed, message:'The {_field_} field confirmation does not match'});
extend('between', {...between, message:'The {_field_} field must be between {min} and {max}'});
extend('regex', {...regex, message:'The {_field_} field format is invalid'});
extend('required', {...required, message:'The {_field_} field is required'});
extend('min', {...min, message:'The {_field_} field must be at least {length} characters'});
extend('min_value', {...min_value, message:'The {_field_} field must be {min} or more'});
extend('max_value', {...max_value, message:'The {_field_} field must be {max} or less'});
extend('email', {...email, message:'The {_field_} field must be a valid email'});
extend('url', ValidateRules.url);
extend('searchTermCsv', ValidateRules.searchTermCsv);
extend('validNewEntepriseId', ValidateRules.validNewEntepriseId);
extend('possibleEnterpriseId', ValidateRules.possibleEnterpriseId);
extend('validSubscriberId', ValidateRules.validSubscriberId);
extend('validSupplierId', ValidateRules.validSupplierId);
extend('validEnrolId', ValidateRules.validEnrolId);
extend('nonRepeatedId', ValidateRules.nonRepeatedId);


import { FilterUtil } from './util/FilterUtil';
const filterUtil = new FilterUtil();
Vue.filter('percentage', filterUtil.percentage);
Vue.filter('tsToString', filterUtil.tsToString);
Vue.filter('maskPassword', filterUtil.maskPassword);


Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
